import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class KeyboardUtils {
  constructor() {
    // static class, can't create an instance
  }

  /**
   * Returns whether the KeyboardEvent represents a Backspace key.
   * @param event
   * @returns {boolean}
   */
  static isBackspaceKey(event) {
    // Note that according to MDN documentation use of the keyCode and which property is deprecated in favor of key. Go figure.
    return event.key === KeyValue.BACKSPACE;
  }
  static simulateKeyDown(key, target) {
    const e = new KeyboardEvent("keydown", {
      key: key,
      bubbles: true
    });
    target?.dispatchEvent(e);
  }
  static simulateKeyPress(key, target) {
    const e = new KeyboardEvent("keypress", {
      key: key,
      bubbles: true
    });
    target?.dispatchEvent(e);
  }
}
_defineProperty(KeyboardUtils, "ENTER_KEY", 13);
export class KeyCode {}

/**
 * String values particular keyboard keys that may be set in the KeyboardEvent.key property.
 * Note that MDN says that KeyboardEvent.keyCode and KeyboardEvent.which are deprecated in favor of KeyboardEvent.key.
 */
_defineProperty(KeyCode, "NUL", 0);
_defineProperty(KeyCode, "BACKSPACE", 8);
_defineProperty(KeyCode, "TAB", 9);
_defineProperty(KeyCode, "LF", 10);
_defineProperty(KeyCode, "CR", 13);
_defineProperty(KeyCode, "ENTER", 13);
_defineProperty(KeyCode, "SHIFT", 16);
_defineProperty(KeyCode, "CTRL", 17);
_defineProperty(KeyCode, "ALT", 18);
_defineProperty(KeyCode, "CAPS_LOCK", 20);
_defineProperty(KeyCode, "ESC", 27);
_defineProperty(KeyCode, "SPACE", 32);
_defineProperty(KeyCode, "PAGE_UP", 33);
_defineProperty(KeyCode, "PAGE_DOWN", 34);
_defineProperty(KeyCode, "END", 35);
_defineProperty(KeyCode, "HOME", 36);
_defineProperty(KeyCode, "LEFT", 37);
_defineProperty(KeyCode, "UP", 38);
_defineProperty(KeyCode, "RIGHT", 39);
_defineProperty(KeyCode, "DOWN", 40);
_defineProperty(KeyCode, "INSERT", 45);
_defineProperty(KeyCode, "DELETE", 46);
_defineProperty(KeyCode, "NUMBER_0", 48);
_defineProperty(KeyCode, "NUMBER_1", 49);
_defineProperty(KeyCode, "NUMBER_2", 50);
_defineProperty(KeyCode, "NUMBER_3", 51);
_defineProperty(KeyCode, "NUMBER_4", 52);
_defineProperty(KeyCode, "NUMBER_5", 53);
_defineProperty(KeyCode, "NUMBER_6", 54);
_defineProperty(KeyCode, "NUMBER_7", 55);
_defineProperty(KeyCode, "NUMBER_8", 56);
_defineProperty(KeyCode, "NUMBER_9", 57);
_defineProperty(KeyCode, "LETTER_A", 65);
_defineProperty(KeyCode, "LETTER_C", 67);
_defineProperty(KeyCode, "LETTER_P", 80);
_defineProperty(KeyCode, "LETTER_S", 83);
_defineProperty(KeyCode, "LETTER_V", 86);
_defineProperty(KeyCode, "LETTER_W", 87);
_defineProperty(KeyCode, "LETTER_X", 88);
_defineProperty(KeyCode, "LETTER_Y", 89);
_defineProperty(KeyCode, "LETTER_Z", 90);
_defineProperty(KeyCode, "NUMPAD_7", 103);
_defineProperty(KeyCode, "NUMPAD_MULTIPLY", 106);
_defineProperty(KeyCode, "NUMPAD_PLUS", 107);
_defineProperty(KeyCode, "NUMPAD_MINUS", 109);
_defineProperty(KeyCode, "NUMPAD_DIVIDE", 111);
_defineProperty(KeyCode, "F1", 112);
_defineProperty(KeyCode, "F2", 113);
_defineProperty(KeyCode, "F3", 114);
_defineProperty(KeyCode, "F4", 115);
_defineProperty(KeyCode, "F5", 116);
_defineProperty(KeyCode, "F6", 117);
_defineProperty(KeyCode, "F7", 118);
_defineProperty(KeyCode, "F8", 119);
_defineProperty(KeyCode, "F9", 120);
_defineProperty(KeyCode, "F10", 121);
_defineProperty(KeyCode, "F11", 122);
_defineProperty(KeyCode, "F12", 123);
export class KeyValue {}

/**
 * Allowable constants to pass to React.KeyboardEvent.getModifierState()
 * The list is published at https://www.w3.org/TR/uievents-key/#keys-modifier
 *
 * TODO - figure out if there are advantages to using getModifierState instead of the event flags.
 * At least, I see that getModifierState isn't present when simulating events via ReactTestUtils.Simulate.keyDown
 */
_defineProperty(KeyValue, "ALT", "Alt");
_defineProperty(KeyValue, "ARROW_DOWN", "ArrowDown");
_defineProperty(KeyValue, "ARROW_LEFT", "ArrowLeft");
_defineProperty(KeyValue, "ARROW_RIGHT", "ArrowRight");
_defineProperty(KeyValue, "ARROW_UP", "ArrowUp");
_defineProperty(KeyValue, "BACKSPACE", "Backspace");
_defineProperty(KeyValue, "CAPS_LOCK", "CapsLock");
_defineProperty(KeyValue, "CONTEXT_MENU", "ContextMenu");
_defineProperty(KeyValue, "CONTROL", "Control");
_defineProperty(KeyValue, "DELETE", "Delete");
_defineProperty(KeyValue, "END", "End");
_defineProperty(KeyValue, "ENTER", "Enter");
_defineProperty(KeyValue, "ESCAPE", "Escape");
_defineProperty(KeyValue, "F1", "F1");
_defineProperty(KeyValue, "F2", "F2");
_defineProperty(KeyValue, "F3", "F3");
_defineProperty(KeyValue, "F4", "F4");
_defineProperty(KeyValue, "F5", "F5");
_defineProperty(KeyValue, "F6", "F6");
_defineProperty(KeyValue, "F7", "F7");
_defineProperty(KeyValue, "F8", "F8");
_defineProperty(KeyValue, "F9", "F9");
_defineProperty(KeyValue, "F10", "F10");
_defineProperty(KeyValue, "F11", "F11");
_defineProperty(KeyValue, "F12", "F12");
_defineProperty(KeyValue, "FN", "Fn");
_defineProperty(KeyValue, "HOME", "Home");
_defineProperty(KeyValue, "INSERT", "Insert");
_defineProperty(KeyValue, "META", "Meta");
_defineProperty(KeyValue, "NUMLOCK", "NumLock");
_defineProperty(KeyValue, "PAGE_DOWN", "PageDown");
_defineProperty(KeyValue, "PAGE_UP", "PageUp");
_defineProperty(KeyValue, "PAUSE", "Pause");
_defineProperty(KeyValue, "PRINT_SCREEN", "PrintScreen");
_defineProperty(KeyValue, "SCROLL_LOCK", "ScrollLock");
_defineProperty(KeyValue, "SHIFT", "Shift");
_defineProperty(KeyValue, "TAB", "Tab");
_defineProperty(KeyValue, "SPACE", " ");
_defineProperty(KeyValue, "ADD", "Add");
_defineProperty(KeyValue, "SUBTRACT", "Subtract");
_defineProperty(KeyValue, "ZERO", "0");
export class KeyModifierTODO {}
/** The Alt (Alternative) key.
 * This key enables the alternate modifier function for interpreting concurrent or subsequent keyboard input.
 * This key value is also used for the Apple Option key.
 */
_defineProperty(KeyModifierTODO, "Alt", "Alt");
/** The Alternate Graphics (AltGr or AltGraph) key. This key is used enable the ISO Level 3 shift modifier (the standard Shift key is the level 2 modifier). See [ISO9995-1]. */
_defineProperty(KeyModifierTODO, "AltGraph", "AltGraph");
/** The Caps Lock (Capital) key. Toggle capital character lock function for interpreting subsequent keyboard input event. */
_defineProperty(KeyModifierTODO, "CapsLock", "CapsLock");
/** The Control or Ctrl key, to enable control modifier function for interpreting concurrent or subsequent keyboard input. */
_defineProperty(KeyModifierTODO, "Control", "Control");
/** The Function switch Fn key.
 * Activating this key simultaneously with another key changes that key's value to an alternate character or function. This key is often handled directly in the keyboard hardware and does not usually generate key events.
 */
_defineProperty(KeyModifierTODO, "Fn", "Fn");
/** The Function-Lock (FnLock or F-Lock) key. Activating this key switches the mode of the keyboard to changes some keys' values to an alternate character or function. This key is often handled directly in the keyboard hardware and does not usually generate key events. */
_defineProperty(KeyModifierTODO, "FnLock", "FnLock");
/** The Meta key, to enable meta modifier function for interpreting concurrent or subsequent keyboard input. This key value is used for the Windows Logo key and the Apple Command or ? key. */
_defineProperty(KeyModifierTODO, "Meta", "Meta");
/** The NumLock or Number Lock key, to toggle numpad mode function for interpreting subsequent keyboard input. */
_defineProperty(KeyModifierTODO, "NumLock", "NumLock");
/** The Scroll Lock key, to toggle between scrolling and cursor movement modes. */
_defineProperty(KeyModifierTODO, "ScrollLock", "ScrollLock");
/** The Shift key, to enable shift modifier function for interpreting concurrent or subsequent keyboard input. */
_defineProperty(KeyModifierTODO, "Shift", "Shift");
/** The Symbol modifier key (used on some virtual keyboards). */
_defineProperty(KeyModifierTODO, "Symbol", "Symbol");
/** The Symbol Lock key. */
_defineProperty(KeyModifierTODO, "SymbolLock", "SymbolLock");
export const SINGLE_CHARACTER = /^.$/;
//# sourceMappingURL=KeyboardUtils.js.map
